import { render, staticRenderFns } from "./CoachModule.vue?vue&type=template&id=06155fba&lang=pug"
import script from "./CoachModule.vue?vue&type=script&lang=js"
export * from "./CoachModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports